import { render, staticRenderFns } from "./SupportTextarea.vue?vue&type=template&id=ac109386&"
import script from "./SupportTextarea.vue?vue&type=script&lang=js&"
export * from "./SupportTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports